import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-104ef829"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc-page" }
const _hoisted_2 = {
  key: 0,
  class: "loadding-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading", -1))

import useWebViewer from '@/composables/document/useDocWebViewer'
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'DocPage',
  setup(__props) {

const route = useRoute()

const docId = computed(() => route.params.id as string)
const userEmail = computed(() => route.query.email as string)

const { isLoadingAllAnnots, isLoading, viewerRef, initWebViewer } = useWebViewer()

onMounted(async () => {
  await initWebViewer({
    documentId: docId.value,
    email: userEmail.value,
    isRenderAllAnnotation: true,
    isUseWebviewer: false,
  })
})

return (_ctx: any,_cache: any) => {
  const _component_DoubleBounceLoader = _resolveComponent("DoubleBounceLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading) || _unref(isLoadingAllAnnots))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_DoubleBounceLoader, { size: 40 }),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "viewer",
      ref_key: "viewerRef",
      ref: viewerRef
    }, null, 512)
  ]))
}
}

})